import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getSession, onAuthChange } from '@/lib/auth';

// Guards all /admin/* pages: only renders children when a Supabase session exists.
export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<'loading' | 'in' | 'out'>('loading');

  useEffect(() => {
    let active = true;
    const sync = (s: unknown) => {
      if (s) sessionStorage.setItem('admin_logged_in', 'true');
      else sessionStorage.removeItem('admin_logged_in');
      setStatus(s ? 'in' : 'out');
    };
    getSession().then((s) => active && sync(s));
    const unsub = onAuthChange((s) => sync(s));
    return () => { active = false; unsub(); };
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-100">
        <i className="ri-loader-4-line animate-spin text-2xl text-primary-500"></i>
      </div>
    );
  }
  if (status === 'out') return <Navigate to="/admin" replace />;
  return <>{children}</>;
}
